
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"17","viewBox":"0 0 17 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.333 14c1.539 0 2.953-.53 4.081-1.407l3.664 3.664 1.178-1.179-3.664-3.663A6.626 6.626 0 0014 7.333 6.674 6.674 0 007.333.667 6.674 6.674 0 00.667 7.333 6.674 6.674 0 007.333 14zm0-11.667c2.758 0 5 2.243 5 5 0 2.758-2.242 5-5 5-2.757 0-5-2.242-5-5 0-2.757 2.243-5 5-5z","fill":"#7E8186"}})])
          )
        }
      }
    